import API from './Api'

const endpointBaseUrl = 'courses';

class KursaiService {
    baseUrl(){
        return endpointBaseUrl;
    }

    getKursai() {
        return API.get(endpointBaseUrl);
    }

    getKursas(id) {
        return API.get(endpointBaseUrl + '/' + id);
    }
}

export default new KursaiService();